import { useEffect, useState } from "react";
import PageLayout from "../components/PageLayout"
import { Wheel as WheelComponent } from "react-custom-roulette";
import axiosInstance from "../api/apiClient";
import ConfettiExplosion from "react-confetti-explosion";
import IconComponent from "../components/Icon";
import { IoMdCloseCircle } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import pointer from "../assets/images/pointer-wheel.png";

const TBRModal = ({book, onClose, open, loading, addToToBeReadList}) => {
    return (
        <div class={`relative z-[99] ${open ? 'block' : 'invisible'}`}>

            <div class="fixed inset-0 bg-gray-500/75 transition-opacity"></div>
            

    <div class="fixed inset-0 z-10 w-screen overflow-y-auto rounded-lg">
        
      <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0 rounded-lg">
       
        <div class="relative transform rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg">
            
          <div class="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4 rounded-lg">
            <div class="sm:flex sm:items-start gap-4">
            
              
                <img src={book['Cover URL']} alt={book.title} className="w-32 h-48 object-cover rounded-lg" />
                    <div>
                        <h3 className="text-lg font-bold">{book['Title']}</h3>
                        <p className="text-sm text-gray-500">{book['Author']}</p>
                        <button
                            className={`mt-4 bg-[#8784D8] text-white font-bold py-2 px-4 rounded disabled:opacity-50`}
                            onClick={addToToBeReadList}
                        >
                            {loading ? 'Adding…' : 'Add to TBR'}
                        </button>
                    </div>
                    
                    {open && <ConfettiExplosion duration={5000} particleCount={100} width={1600} zIndex={100} />}
                     
                    <IconComponent
                      icon={IoMdCloseCircle}
                      width={30}
                      color="#60637A"
                      className="absolute top-[10px] right-[10px] cursor-pointer"
                      onClick={() => onClose()}
                    />
            </div>
            
          </div>
        </div>
      </div>
    </div>
  </div>
    )
}

const Wheel = () => {
    const [mustSpin, setMustSpin] = useState(false);
    const [prizeNumber, setPrizeNumber] = useState(0);
    const [data, setData] = useState([]);
    const [bookData, setBookData] = useState({});
    const [loading, setLoading] = useState(false);
    const [open, setOpen] = useState(false);
    const navigate = useNavigate();

  const handleSpinClick = () => {
    setBookData({});
    const newPrizeNumber = Math.floor(Math.random() * data.length);
    setPrizeNumber(newPrizeNumber);
    setMustSpin(true);
  };

  const addToToBeReadList = async () => {
    // beslissen welke positien er moeten worden toegevoegd aan TBR
        setLoading(true);
        try {
            await axiosInstance.get('/getUserBookshelves').then(async (data) => {
                const toRead = data.find(bs => bs.bookshelf_name === "to-be-read");
                const newIndex = toRead.books.length + 1;

                 const body = {
                    book_id: bookData['Book Id'],
                    bookshelf_id: 621,
                    position: newIndex,
                };

                await axiosInstance.post('/addBookToShelf', body).then(() => {
                    navigate('/bookshelf?type=tbr')
                });
            })
    
        } catch (e) {
        console.error(e);
        } finally {
            setLoading(false);
        }
  }

    const getAllBooks = async () => {
        await axiosInstance.get('/getAllBooks').then((data) => {
            const filteredData = data.filter((book) => book['Exclusive Shelf'] === 'to-read' && book['Owned Copies'] > 0 && (book['Serie'] === null || book['Serie Position'] === 1));
            setData(filteredData.map((b) => ({ option: b['Title'], id: b['Book Id'] })));
        });
    };

    const getBookData = async (id) => {
        await axiosInstance.get(`/getBook/${id}`).then((data) => {
            console.log('data', data);
            setBookData(data[0]);
        });
    };

    useEffect(() => {
        getAllBooks();
    }, []);

    useEffect(() => {
        console.log(bookData);
    }, [bookData]);

    useEffect(() => {
        if (prizeNumber) {
            getBookData(data[prizeNumber].id);
            console.log(data[prizeNumber].id);
        }
        
    }, [prizeNumber]);

    useEffect(() => {
        if (!mustSpin && prizeNumber !== 0) {
            setOpen(true);
        
        }
    }, [mustSpin]);

    return(
        <PageLayout
            headerText="Spin Your Next Read"
            text={`You've ${data.length} books in your library that you havn't read yet. Spin the wheel to find out which book you should start reading next!`}
        >
            <TBRModal book={bookData} open={open} onClose={() => setOpen(false)} loading={loading} addToToBeReadList={addToToBeReadList}/>
           
            <div className="bg-white rounded-3xl shadow-lg p-4 min-h-20">

                <div className="flex flex-col items-center relative">
                    {(data.length > 0) &&
                        <>
                            <WheelComponent
                                    mustStartSpinning={mustSpin}
                                    prizeNumber={prizeNumber}
                                    data={data}
                                    outerBorderColor={["#f2f2f2"]}
                                    outerBorderWidth={[10]}
                                    innerBorderColor={["#f2f2f2"]}
                                    radiusLineColor={["#dedede"]}
                                    radiusLineWidth={[1]}
                                    fontSize={6}
                                    textColors={["#ffffff"]}
                                    textDistance={75}
                                    spinDuration={.5}
                                    // pointerProps={{src: pointer, style: { color: "#f2f2f2" } }}
                                    backgroundColors={['#8884d8', '#82ca9d', '#ffc658', '#ff7f50', '#00C49F', '#FFBB28', '#FF8042']}
                                    onStopSpinning={() => {
                                        setMustSpin(false);
                                        console.log(data[prizeNumber]);
                                    }}
                                />
                            <button className="absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-white shadow-lg text-[#60637A] font-bold px-4 py-2 rounded-lg z-10" onClick={handleSpinClick}>{mustSpin ? "SPINNING..." : "SPIN"}</button>
                        </>
                    }  
                </div>
            </div>
           
        </PageLayout>
    )
}

export default Wheel